import { render, staticRenderFns } from "./NegativeStatementInfoModal.vue?vue&type=template&id=a942222c&"
import script from "./NegativeStatementInfoModal.vue?vue&type=script&lang=js&"
export * from "./NegativeStatementInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports